import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
// import { version } from '../package.json'
import { validateAndParseIds } from './utils/validateAndParseIds';
import { validateAndTransformRecords } from './utils/validateAndTransformRecords';
import { getType } from './utils/getType';
import axios from 'axios';
import { BRIDGE_URL, BASE_URL } from './constants';
var KivaProxy = /*#__PURE__*/function () {
  function KivaProxy(_ref) {
    var endpoint = _ref.endpoint,
      _ref$parameters = _ref.parameters,
      parameters = _ref$parameters === void 0 ? {} : _ref$parameters,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$driver = _ref.driver,
      driver = _ref$driver === void 0 ? 'default' : _ref$driver;
    _classCallCheck(this, KivaProxy);
    this.endpoint = endpoint;
    this.parameters = JSON.parse(JSON.stringify(parameters));
    this.config = config;
    this.$httpDrivers = KivaProxy.global.httpDrivers;
    this.httpDriver = driver;
  }
  _createClass(KivaProxy, [{
    key: "all",
    value: function all() {
      return this.submit('get', "/".concat(this.endpoint));
    }
  }, {
    key: "find",
    value: function find(ids) {
      var suffix = validateAndParseIds(ids);
      return this.submit('get', "/".concat(this.endpoint, "/").concat(suffix));
    }
  }, {
    key: "create",
    value: function create(records) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.submit('post', "/".concat(this.endpoint), _objectSpread(_objectSpread({}, config), {}, {
        records: validateAndTransformRecords(records)
      }));
    }
  }, {
    key: "update",
    value: function update(records) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.submit('patch', "/".concat(this.endpoint), _objectSpread(_objectSpread({}, config), {}, {
        records: validateAndTransformRecords(records)
      }));
    }
  }, {
    key: "destroy",
    value: function destroy(ids) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (ids) {
        var suffix = validateAndParseIds(ids);
        return this.submit('delete', "/".concat(this.endpoint, "/").concat(suffix), {
          data: config
        });
      } else {
        return this.submit('delete', "/".concat(this.endpoint), {}, {
          data: config
        });
      }
    }
  }, {
    key: "submit",
    value: function submit(requestType, url) {
      var _this = this;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      requestType = requestType.toLowerCase();
      var driver = this.getDriver();
      return new Promise(function (resolve, reject) {
        if (requestType === 'get') {
          data = _this.config;
        }
        // console.log("this.getParameterString()",this.getParameterString())
        driver[requestType](url + _this.getParameterString(), data, _this.config).then(function (_ref2) {
          var data = _ref2.data;
          resolve(data);
        }).catch(function (_ref3) {
          var response = _ref3.response;
          if (response) {
            reject(response.data);
          } else {
            reject(response);
          }
        });
      });
    }
  }, {
    key: "setViewId",
    value: function setViewId(id) {
      this.setParameter('viewId', id);
      return this;
    }
  }, {
    key: "getEmpty",
    value: function getEmpty(boolean) {
      this.setParameter('getEmpty', !!boolean);
      return this;
    }
  }, {
    key: "setFields",
    value: function setFields(array) {
      this.setParameter('fields', array);
      return this;
    }
  }, {
    key: "setFilters",
    value: function setFilters(array) {
      this.setParameter('filters', array);
      return this;
    }
  }, {
    key: "setKeyword",
    value: function setKeyword(string) {
      this.setParameter('keyword', string);
      return this;
    }
  }, {
    key: "setStart",
    value: function setStart(integer) {
      this.setParameter('start', integer);
      return this;
    }
  }, {
    key: "setLimit",
    value: function setLimit(integer) {
      this.setParameter('limit', integer);
      return this;
    }
  }, {
    key: "setSort",
    value: function setSort(string) {
      if (string != null) {
        this.setParameter('sort', string);
      }
      return this;
    }
  }, {
    key: "setDir",
    value: function setDir(string) {
      if (string != null) {
        this.setParameter('dir', string);
      }
      return this;
    }
  }, {
    key: "getDriver",
    value: function getDriver() {
      if (this.$httpDrivers.hasOwnProperty(this.httpDriver)) {
        return this.$httpDrivers[this.httpDriver];
      } else {
        throw new Error('http driver not found');
      }
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(parameters) {
      this.config.headers = _objectSpread(_objectSpread({}, this.config.headers), parameters);
      return this;
    }
  }, {
    key: "setParameters",
    value: function setParameters(parameters) {
      var _this2 = this;
      Object.keys(parameters).forEach(function (key) {
        _this2.parameters[key] = parameters[key];
      });
      return this;
    }
  }, {
    key: "setParameter",
    value: function setParameter(parameter, value) {
      this.parameters[parameter] = value;
      return this;
    }
  }, {
    key: "removeParameters",
    value: function removeParameters(parameters) {
      var _this3 = this;
      parameters.forEach(function (parameter) {
        delete _this3.parameters[parameter];
      });
      return this;
    }
  }, {
    key: "removeParameter",
    value: function removeParameter(parameter) {
      delete this.parameters[parameter];
      return this;
    }
  }, {
    key: "clearParameters",
    value: function clearParameters() {
      this.parameters = {};
    }
  }, {
    key: "getParameterString",
    value: function getParameterString() {
      var _this4 = this;
      var keys = Object.keys(this.parameters);
      var stringifyRequiredTypes = ['Array', 'Object'];
      var parameterStrings = keys.map(function (key) {
        var value = _this4.parameters[key];
        if (stringifyRequiredTypes.includes(getType(value))) {
          value = JSON.stringify(value);
        }
        return "".concat(key, "=").concat(value);
      });
      return parameterStrings.length === 0 ? '' : "?".concat(parameterStrings.join('&'));
    }
  }]);
  return KivaProxy;
}();
export { KivaProxy as default };
KivaProxy.global = KivaProxy.prototype;
KivaProxy.global.config = {};
KivaProxy.global.createHttpDriver = function (name, config) {
  if (this.httpDrivers.hasOwnProperty(name)) {
    throw new Error("".concat(name, " http driver already registed"));
  }
  this.httpDrivers[name] = axios.create(config);
};
KivaProxy.global.httpDrivers = {};
// KivaProxy.global.version = version

KivaProxy.global.createHttpDriver('direct', {
  withCredentials: true,
  baseURL: "".concat(BASE_URL),
  headers: {}
});
KivaProxy.global.createHttpDriver('default', {
  withCredentials: true,
  baseURL: "".concat(BRIDGE_URL, "/data"),
  headers: {}
});